import { render, staticRenderFns } from "./09.vue?vue&type=template&id=b4fc4744&scoped=true&"
import script from "./09.vue?vue&type=script&lang=js&"
export * from "./09.vue?vue&type=script&lang=js&"
import style0 from "./09.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./09.vue?vue&type=style&index=1&id=b4fc4744&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fc4744",
  null
  
)

export default component.exports